import { useState } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color, EL_COLORS } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { FlexCenVer } from '@/UI/styles';
import { CommunityIcon } from '@/UI/Icons/CommunityIcon';
import { ChevronRightIcon } from '@/UI/Icons/MuiIcons';
import PublishToCommunityModal from './PublishToCommunityModal';

const PublishToCommunityPanel = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <FlexCenVer
        role="button"
        tabIndex={0}
        onClick={() => setIsModalOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsModalOpen(true);
          }
        }}
        sx={{
          justifyContent: 'space-between',
          background: color.Black92,
          border: `1px solid ${EL_COLORS.BoxBorder}`,
          borderRadius: 2,
          p: 3,
          cursor: 'pointer',
          '&:hover': { background: color.Black84 },
        }}
      >
        <FlexCenVer sx={{ gap: 0.5 }}>
          <CommunityIcon width={24} height={24} />
          <Typography variant="body-sm-rg">
            {t(I18N_KEYS.SHARE_WORKFLOW_MODAL.PUBLISH_TO_FIGMA_COMMUNITY.ROW_LABEL)}
          </Typography>
        </FlexCenVer>
        <ChevronRightIcon sx={{ fontSize: 24 }} />
      </FlexCenVer>
      <PublishToCommunityModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default PublishToCommunityPanel;
